import { expand } from 'uri-template-lite';
import { Page, PageRequestParams } from '../../common/queryClient';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataSubjectUrl } from './DataSubjectUrl';
import { ISODate } from '../../common/utils';
import { DataSubjectInputType } from '../schema/types';
import { DataSubjectInputSchemaPageSchema } from '../schema/DataSubjectSchema';

export interface DataSubjectInputFilters {
  id: number;
  valueDate: ISODate;
}

type DataSubjectInputsQueryParams = DataSubjectInputFilters & PageRequestParams;

const getDataSubjectInputs = (params?: DataSubjectInputsQueryParams) =>
  apiClient
    .get<
      Page<DataSubjectInputType>
    >(expand(DataSubjectUrl.DATASUBJECT_INPUTS, params))
    .then((response) => DataSubjectInputSchemaPageSchema.parse(response.data));

export const useDataSubjectInputsQuery = createApiQueryHook(
  ['dataSubjectInputs'],
  getDataSubjectInputs,
);
